/*
 * Copyright Mimic Networks, Inc. 2024.
 */

import { Form } from 'antd';
import { useState } from 'react';

import { CreateUser } from '@/client';
import { InviteUserForm } from '@/pages/InviteUser/InviteUserForm';
import { InviteUserModal } from '@/pages/InviteUser/InviteUserModal';

export function InviteUserPage() {
  const [form] = Form.useForm<CreateUser>();
  const [selectedRole, setSelectedRole] = useState<string>('editor');

  return (
    <InviteUserModal setSelectedRole={setSelectedRole} form={form}>
      <InviteUserForm form={form} selectedRole={selectedRole} setSelectedRole={setSelectedRole} />
    </InviteUserModal>
  );
}
